import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/home/Home';
import About from './pages/about/About';
import Contact from './pages/contact/Contact';
import Footer from './components/Footer';
import "bootstrap-icons/font/bootstrap-icons.css";
import WeekendTours from "./pages/tours/WeekendTours";
import TourDetails from "./pages/tours/TourDetails";
import HomeFaqs from "./components/faqs/HomeFaqs";
import ClientTestimonials from "./components/testimonials/ClientTestimonials";
import Khajuraho from "./pages/khajuraho/Khajuraho";
import KhajurahoDetail from "./pages/khajuraho/KhajurahoDetail";
import ScrollRevealGallery from './pages/ScrollRevealGallery/ScrollRevealGallery';
import FloatingContactButtons from './components/common/FloatingContactButtons';
import Preloader from './components/common/Preloader';
import PolicySection from './pages/yatra/PolicySection';
import PageTransition from './components/PageTransition';
import ScrollToTop from './components/ScrollToTop';
import BusRent from './pages/busrent/BusRent';
import Services from './pages/services/Services';
import PrivacyPolicy from './pages/policies/PrivacyPolicy';
import TermsConditions from './pages/policies/TermsConditions';
import CancellationPolicy from './pages/policies/CancellationPolicy';
import Disclaimer from './pages/policies/Disclaimer';
import TransportCharges from './pages/transport/TransportCharges';
import Hotels from './pages/hotels/Hotels';
import Taxi from './pages/taxi/Taxi';

const App = () => {
  return (
    <>
      <Preloader />
      <Header />
       <ScrollToTop/>
      <PageTransition>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/tours" element={<WeekendTours />} />
          <Route path="/tours/:id" element={<TourDetails />} />
          <Route path="/faqs" element={<HomeFaqs />} />
          <Route path="/testimonials" element={<ClientTestimonials />} />
          <Route path="/khajuraho" element={<Khajuraho />} />
          <Route path="/khajuraho/:id" element={<KhajurahoDetail />} />
          <Route path="/scroll-gallery" element={<ScrollRevealGallery />} />

          <Route path="/hotels" element={<Hotels />} />
          <Route path="/taxi" element={<Taxi />} />
          <Route path="/busrent" element={<BusRent />} />
          <Route path="/services" element={<Services />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/cancellation-policy" element={<CancellationPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/transport-charges" element={<TransportCharges />} />

        </Routes>
       
      </PageTransition>
 <FloatingContactButtons />
      <Footer />
    </>
  );
};

export default App;
